export function validIdsURL(array){
    const urlInvalidCharsRegex = /[^-\w\d._~]/;
    return array.filter(id => urlInvalidCharsRegex.test(id));
  }

export function validIdsURLElement(array){
    const urlInvalidCharsRegex = /[^-\w\d._~]/;
    return array.filter(id => urlInvalidCharsRegex.test(id.value));
  }